export const ACCOUNT_REQUEST = "ACCOUNT_REQUEST"
export const ACCOUNT_REQUEST_SUCCESS = "ACCOUNT_REQUEST_SUCCESS"
export const ACCOUNT_REQUEST_ERROR = "ACCOUNT_REQUEST_ERROR"

export const PASSWORD_CHANGE_REQUEST = "PASSWORD_CHANGE_REQUEST"
export const PASSWORD_CHANGE_SUCCESS = "PASSWORD_CHANGE_SUCCESS"
export const PASSWORD_CHANGE_ERROR = "PASSWORD_CHANGE_ERROR"
